import { render, staticRenderFns } from "./GalaxyStar.vue?vue&type=template&id=049fc2a0&scoped=true"
import script from "./GalaxyStar.vue?vue&type=script&lang=js"
export * from "./GalaxyStar.vue?vue&type=script&lang=js"
import style0 from "./GalaxyStar.vue?vue&type=style&index=0&id=049fc2a0&prod&lang=scss&scoped=true"
import style1 from "./GalaxyStar.vue?vue&type=style&index=1&id=049fc2a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049fc2a0",
  null
  
)

export default component.exports